module.exports = __webpack_public_path__ + "static/toy-02d70ace0368fc78c078483b098c3b81.jpeg";